import React from 'react'
import './footer.css'
function Footer() {
  return (
    <div className='container-fluid footer-container'>
      <div className="col-md-12">
        <p className='text-center m-0 text-white pt-2'>Powered by - <span className='text-bolder'><a className='text-light' href="https://accunityhr.com" target='_blank'>Accunity HR</a></span></p>
      </div>
    </div>
  )
}

export default Footer
